import i18n from "i18next";

import type { Medium } from "api/services/appointment/schemas/shared";

export function translateAppointmentMedium(medium: Medium): string {
  const keyMap: Record<Medium, string> = {
    face_to_face: i18n.t("messages.appointments.types.FACE_TO_FACE"),
    phone: i18n.t("messages.appointments.types.PHONE"),
    video: i18n.t("messages.appointments.types.VIDEO"),
  };

  return keyMap[medium] || "";
}
